import { render } from "./HtmlPreview.vue?vue&type=template&id=01960d36&scoped=true"
import script from "./HtmlPreview.vue?vue&type=script&lang=js"
export * from "./HtmlPreview.vue?vue&type=script&lang=js"

import "./HtmlPreview.vue?vue&type=style&index=0&id=01960d36&scoped=true&lang=css"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01960d36"]])

export default __exports__